module.exports = __webpack_public_path__ + "img/img_biaozhun@2x.409365af.png";